import { SvgIcon, SvgIconProps } from '@mui/material';

const PauseFilled = ({ fill, fillOpacity, sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      data-testid="PauseFilledIcon"
      sx={{
        fill: fill,
        fillOpacity: fillOpacity ?? 1,
        ...sx
      }}
    >
      <path d="M6 20V4H10V20H6Z" />
      <path d="M14 20V4H18V20H14Z" />
    </SvgIcon>
  );
};

export default PauseFilled;
